/* Cats Garage — product-form.js
   Variant picker for the PDP ([data-cg-pdp]).
   - Single-option products: radios are name="id" and post the variant id directly
     (works without JS); this script only syncs price/earn/stock panels.
   - Multi-option products: radios carry data-option-index; the matched variant id
     is written into the hidden input[name="id"].
   Per-variant price + Cat Paradise Rewards panels are server-rendered ([data-variant-panel])
   and toggled via the hidden attribute. Vanilla JS, loaded with defer. */
(function () {
  'use strict';

  function init(root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    var idInput = root.querySelector('input[type="hidden"][name="id"]');
    var submit = root.querySelector('[data-pdp-submit]');
    var stock = root.querySelector('[data-pdp-stock]');
    var cartError = root.querySelector('[data-cart-error]');

    function findById(id) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) return variants[i];
      }
      return null;
    }

    function currentVariant() {
      // Case 1: radios named "id" (single-option products).
      var checkedId = root.querySelector('input[type="radio"][name="id"]:checked');
      if (checkedId) return findById(Number(checkedId.value));

      // Case 2: option radios + hidden id input (multi-option products).
      var optionRadios = root.querySelectorAll('input[type="radio"][data-option-index]:checked');
      if (optionRadios.length) {
        var selected = [];
        optionRadios.forEach(function (radio) {
          selected[Number(radio.getAttribute('data-option-index'))] = radio.value;
        });
        for (var i = 0; i < variants.length; i++) {
          var match = true;
          for (var j = 0; j < selected.length; j++) {
            if (selected[j] !== undefined && variants[i].options[j] !== selected[j]) {
              match = false;
              break;
            }
          }
          if (match) return variants[i];
        }
        return null;
      }

      // Case 3: no picker (single variant).
      return idInput ? findById(Number(idInput.value)) : variants[0];
    }

    function update(fromUser) {
      var variant = currentVariant();

      root.querySelectorAll('[data-variant-panel]').forEach(function (panel) {
        var show = variant && Number(panel.getAttribute('data-variant-panel')) === variant.id;
        if (show) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });

      if (idInput && variant) idInput.value = variant.id;
      // An add-to-cart error was about the previous variant.
      if (fromUser && cartError) cartError.hidden = true;

      var available = !!(variant && variant.available);

      if (stock) {
        stock.textContent = variant ? (available ? 'In stock' : 'Out of stock') : 'Unavailable';
        stock.classList.toggle('is-in', available);
        stock.classList.toggle('is-out', !available);
      }

      if (submit) {
        submit.disabled = !available;
        submit.textContent = available
          ? (submit.getAttribute('data-label-add') || 'Add to cart')
          : (submit.getAttribute('data-label-soldout') || 'Sold out');
      }

      // product-gallery.js swaps to the variant's photo.
      if (fromUser && variant) {
        root.dispatchEvent(new CustomEvent('cg:variant-change', { bubbles: true, detail: { variant: variant } }));
      }

      if (fromUser && variant && window.history && history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        } catch (e) {
          /* no-op */
        }
      }
    }

    root.addEventListener('change', function (event) {
      if (event.target.matches && event.target.matches('input[type="radio"]')) update(true);
    });

    update(false);
  }

  document.querySelectorAll('[data-cg-pdp]').forEach(init);
})();
